import clsx from "clsx";
import React from "react";
import { CaptionedImage } from "../CaptionedImage/CaptionedImage";
import { ImageGalleryList, ImageGalleryListProps } from "./ImageGalleryList";
import css from "./image-gallery.module.scss";

interface ImageGalleryImagePaneProps<Keys extends readonly string[]> extends Omit<ImageGalleryListProps<Keys>, "onGetItem"> { }

export const ImageGalleryImagePane = <Keys extends readonly string[]>({ className, ...props }: ImageGalleryImagePaneProps<Keys>): React.FunctionComponentElement<ImageGalleryImagePaneProps<Keys>> =>
    <ImageGalleryList
        {...props}
        className={clsx(css["image-pane"], className)}
        data-image-gallery-pane
        onGetItem={(key, captionedImageProps) => <CaptionedImage {...captionedImageProps} data-image-gallery-id={key} key={key} />}
    />;
